import { FootballPosition } from "refsix-js-models";

export { FootballPosition };

export interface PositionConfig {
    code: FootballPosition;
    top: string;
    left: string;
    depth: 'far' | 'mid-far' | 'mid' | 'mid-near' | 'near';
}

export const POSITION_CONFIGS: PositionConfig[] = [
    // Attack (top of screen - far end, smallest due to perspective)
    { code: FootballPosition.S, top: '6%', left: '50%', depth: 'far' },
    { code: FootballPosition.CF, top: '14%', left: '50%', depth: 'mid-far' },

    // Attacking Midfield
    { code: FootballPosition.AM, top: '22%', left: '50%', depth: 'mid-far' },

    // Midfield (medium size markers)
    { code: FootballPosition.LW, top: '30%', left: '15%', depth: 'mid' },
    { code: FootballPosition.CM, top: '30%', left: '50%', depth: 'mid' },
    { code: FootballPosition.RW, top: '30%', left: '85%', depth: 'mid' },

    // Defensive Midfield
    { code: FootballPosition.DM, top: '38%', left: '50%', depth: 'mid-near' },

    // Defense (back line - large markers, near perspective)
    { code: FootballPosition.LWB, top: '46%', left: '25%', depth: 'mid-near' },
    { code: FootballPosition.RWB, top: '46%', left: '75%', depth: 'mid-near' },
    { code: FootballPosition.LB, top: '53%', left: '30%', depth: 'near' },
    { code: FootballPosition.CB, top: '53%', left: '50%', depth: 'near' },
    { code: FootballPosition.RB, top: '53%', left: '70%', depth: 'near' },

    // Goalkeeper (bottom of screen - nearest, largest due to perspective)
    { code: FootballPosition.GK, top: '62%', left: '50%', depth: 'near' },
];
